import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { ImpersonationService } from './impersonation.service';
import { TestUser } from './impersonation.types';

/**
 * @deprecated use inject(ImpersonationService).impersonableUsers$ instead
 */
@Injectable({ providedIn: 'root' })
export class ImpersonationMappingService {
    /**
     * @deprecated use inject(ImpersonationService).impersonableUsers$ instead
     */
    readonly allowedTestUsers$: Observable<TestUser[]> = inject(ImpersonationService).allowedTestUsers$;
}
